import React, {useCallback, useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router';
import {useTranslation} from 'react-i18next';
import Modal from '../../components/Modal';
import {AxiosError} from 'axios';
import {Location} from 'history';
import client from 'lib/CommonApi/client';
import {callAlertWeb, callNativeWeb, footerShowEventWeb, hideProgressWeb, showProgressWeb} from 'common/appInterface';
import stringUtils from "common/stringUtils";

const CardAutoDebitPage: React.FC = () => {
	/** Location State */
	const location = useLocation() as Location<LocationState>;
	/** Navigate */
	const navigate = useNavigate();
	/** 다국어처리 */
	const {t, i18n} = useTranslation();
	
	const screenId = 'SERV13';
	const screenName = t('SERV13.title');
	
	const cardInfo = location.state.info;
	const cardWithdrawAmount = location.state.staticInfo.cardWithdrawAdditionalAmount;
	
	const [debitState, setDebitState] = useState<CardDebitState>(location.state.userInfo);
	
	const [isLoad, setLoad] = useState(false);
	const [isDebitModal, setDebitModal] = useState(false);
	
	/** 뒤로가기 처리 (backKeyEvent_App (APP > WEB)) */
	const callbackBackkeyEvent = useCallback(() => {
			if (location.state.linkOpenMenu === 'main') {
				navigate("/main", {
					state: {
						query: location.state.query
						, swiperIndex: location.state.swiperIndex
						, tabIndex: location.state.tabIndex
						, from: location.pathname
					}
				});
			} else {
				navigate(-1);
			}
		}, [
			navigate, location.state.linkOpenMenu, location.state.query,
			location.state.swiperIndex, location.state.tabIndex, location.pathname
		]
	);
	
	/** 카드출금동의여부조회 */
	const callDebitState = useCallback(async () => {
		showProgressWeb();
		setLoad(true);
		
		await client.get('/api/app/manage/debit/state', {
			params: {
				...location.state.query,
				alternativeCardNo: cardInfo.alternativeCardNo
			}
		}).then(response => {
			setDebitState(response.data.response);
			setLoad(false);
		}).catch((e: AxiosError) => {
			callAlertWeb('ERROR', '99', e.message);
		}).finally(() => {
			hideProgressWeb();
		});
	}, [cardInfo.alternativeCardNo, location.state.query]);
	
	/** 카드출금동의여부 호출 */
	const callDebitChange = useCallback(async (code: boolean) => {
		showProgressWeb();
		setLoad(true);
		
		await client.patch('/api/app/manage/debit', {
			...location.state.query,
			...debitState,
			cardMemberNo: debitState?.cardMemberNo,
			cardAutoDebitYn: code ? 'N' : 'Y'
		}).then((response) => {
			callDebitState();
			// 정상
			if (response.data.code === '00') {
				setDebitModal(true);
			} else {
				callAlertWeb('ERROR', response.data.code, response.data.message);
			}
		}).catch((e: AxiosError) => {
			callAlertWeb('ERROR', '99', e.message);
		}).finally(() => {
			setLoad(false);
			hideProgressWeb();
		});
	}, [location.state.query, debitState, callDebitState]);
	
	/** 카드자동출금동의 모달닫기 */
	const closeDebitModal = () => {
		setDebitModal(false);
	};
	
	// 최초실행
	useEffect(() => {
		// 언어설정
		i18n.changeLanguage(location.state.query.languageCode);
		// callNative_Web 처리 (WEB > APP)
		callNativeWeb(screenId, screenName, location.state.from === '/intro' ? 'Y' : 'N');
		// 하단바 숨기기
		footerShowEventWeb('N');
		
		console.log('QUERY STATE');
		console.log(location.state);
		console.log(cardInfo);
		
		callDebitState();
		
		// 최초한번실행 useEffect() Warning 제거
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	
	// 뒤로가기 이벤트 리스너 (backKeyEvent_App (APP > WEB))
	useEffect(() => {
		document.addEventListener('backpress', callbackBackkeyEvent);
		return () => document.removeEventListener('backpress', callbackBackkeyEvent);
	}, [callbackBackkeyEvent]);
	
	return (
		<section className='contents pdt30'>
			<div id='container'>
				<div className="listtyp01">
					<div className='inner'>
						<section className='manage'>
							<div className={debitState?.cardAutoDebitYn === 'Y' ? 'listbox on' : 'listbox'}>
								<div className='radioBox'>
									<div className='g-pay'>
										<p>{t('SERV13.header01')}</p>
										<br/>
										<div className='toggleBox'>
											<div className='inputBox'>
												<input type='checkbox' id='toggle01'
													   checked={debitState?.cardAutoDebitYn === 'Y'}
													   onChange={() => callDebitChange(debitState?.cardAutoDebitYn === 'Y')}
													   disabled={isLoad}/>
												<span/>
												<label htmlFor='toggle01'></label>
											</div>
										</div>
									</div>
								</div>
							</div>
							<p className='tit mgt15'>
								{t('SERV13.explan01')}
							</p>
						</section>
					</div>
				</div>
				{/* 카드 자동 출금 설정 */}
				<Modal isOpen={isDebitModal} contentLabel='modal' onRequestClose={closeDebitModal}
					   className='popTyLayer2'
					   overlayClassName='dim' closeTimeoutMS={0}>
					<p className='message'>{t(`SERV13.popupExplan01.${debitState?.cardAutoDebitYn}`)}</p>
					<div className='btnWrapTy02'>
						<button type='button' className='btnPrimaryTy01' onClick={closeDebitModal}>
							<span>{t('COMMON.button.confirm')}</span></button>
					</div>
				</Modal>
			</div>
		</section>
	);
};

export default CardAutoDebitPage;